module.exports = __webpack_public_path__ + "/images/cover-pareja-pensativa-2x.13e0f8e.jpg";